import React, { useEffect, useState } from "react";
import CustomInput from "../CustomInput/CustomInput";
import { useStateContext } from "../Context/StateContext";
import search from "../../assets/images/search-lg.svg";
import { useLocation } from "react-router-dom";

const CardHeader = ({
  addmodel,
  setOpenFilter,
  params,
  setParams,
  modals,
  setModals,
  headerTitle,
  hidefilter,
  searchPlaceholder,
}) => {
  const location = useLocation();
  const { currentCardTitle, currentUrl } = useStateContext();
  const [searchtext, setSearchtext] = useState(params?.search_key || "");
  const [debouncedSearchtext, setDebouncedSearchtext] = useState(searchtext);

  useEffect(() => {
    setSearchtext(params?.search_key || "");
  }, [params?.search_key]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchtext(searchtext);
    }, 600);
    return () => {
      clearTimeout(handler);
    };
  }, [searchtext]);


  useEffect(() => {
    setParams((prevParams) => ({
      ...prevParams,
      search_key: debouncedSearchtext,
      page: 1,
    }));
  }, [debouncedSearchtext, setParams]);

  return (
    <div className="px-3 ">
      <div className="category-wrapper d-flex justify-content-center flex-column w-100">
        <div className="d-flex justify-content-between align-items-center sub-head">
          <h4>{headerTitle ? headerTitle : currentCardTitle ? currentCardTitle : ""}</h4>
          {hidefilter ||
          location.pathname === "/membership" ||
          currentUrl === "Customer Membership" ||
          currentUrl === "Category" ||
          currentUrl === "Service" ||
          location.pathname === "/referallist" ||
          location.pathname === "/services" ||
          location.pathname === "/categories" ? (
            ""
          ) : (
            <button
              className="submit-btn filter-btn"
              onClick={() => setModals(!modals)}
            >
              <span>
                <i className="fa-solid fa-filter"></i> Filter
              </span>
            </button>
          )}
        </div>
        <div className="searchbar d-flex justify-content-between align-items-center">
          <div className="col-md-6 p-0">
            <div className="search-bar d-flex w-100">
              <button className="btn">
                <img src={search} alt="search" />
              </button>
              <CustomInput
                value={searchtext}
                placeholder={searchPlaceholder || "Search details here"}
                style={{ width: "100%", marginBottom: 20 }}
                onChange={({ target }) => setSearchtext(target.value)}
              />
              {searchtext && (
                <button
                  onClick={() => setSearchtext("")}
                  className="mr-3"
                  style={{ color: "#b3b3b3" }}
                >
                  <i className="fa fa-times"></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardHeader;
